import { z } from "zod";
/** Şarj (Prompt 19, ADR 0019) — sabit listeler ve Türkçe etiketleri. OCPP sabitleri `@station/ev-core`'dakiyle aynıdır. */
export const EV_OPERATION_MODELS = ["OWN_CSMS", "NETWORK_PARTNER"];
export const evOperationModelSchema = z.enum(EV_OPERATION_MODELS);
export const EV_OPERATION_MODEL_LABELS = {
    OWN_CSMS: "Kendi şarj yönetimi (OCPP bu sunucuya)",
    NETWORK_PARTNER: "Şarj ağı işletmecisi (veri içe aktarılır)",
};
export const EV_LOAD_METHODS = ["OFF", "EQUAL", "PRIORITY"];
export const evLoadMethodSchema = z.enum(EV_LOAD_METHODS);
export const EV_LOAD_METHOD_LABELS = {
    OFF: "Kapalı (sınır uygulanmaz)",
    EQUAL: "Eşit paylaştırma",
    PRIORITY: "Öncelikli paylaştırma",
};
export const EV_UNKNOWN_ID_TAG_POLICIES = ["REJECT", "ACCEPT_POS_PAYMENT"];
export const evUnknownIdTagPolicySchema = z.enum(EV_UNKNOWN_ID_TAG_POLICIES);
export const EV_UNKNOWN_ID_TAG_POLICY_LABELS = {
    REJECT: "Reddet",
    ACCEPT_POS_PAYMENT: "Kabul et, ödeme kasada",
};
export const EV_CONNECTOR_STATUSES = [
    "Available",
    "Preparing",
    "Charging",
    "SuspendedEVSE",
    "SuspendedEV",
    "Finishing",
    "Reserved",
    "Unavailable",
    "Faulted",
];
export const evConnectorStatusSchema = z.enum(EV_CONNECTOR_STATUSES);
export const EV_CONNECTOR_STATUS_LABELS = {
    Available: "Boş",
    Preparing: "Hazırlanıyor",
    Charging: "Şarj ediyor",
    SuspendedEVSE: "Askıda (ünite)",
    SuspendedEV: "Askıda (araç)",
    Finishing: "Bitti, araç bağlı",
    Reserved: "Rezerve",
    Unavailable: "Kullanım dışı",
    Faulted: "Arızalı",
};
export const EV_SESSION_PHASE_VALUES = [
    "STARTED",
    "CHARGING",
    "FINISHING",
    "COMPLETED",
    "FAULTED",
    "RECOVERED",
];
export const evSessionPhaseSchema = z.enum(EV_SESSION_PHASE_VALUES);
export const EV_SESSION_PHASE_LABELS = {
    STARTED: "Başladı",
    CHARGING: "Şarj ediyor",
    FINISHING: "Bitti, bekleme",
    COMPLETED: "Tamamlandı",
    FAULTED: "Arıza",
    RECOVERED: "Kurtarılan oturum",
};
export const EV_SESSION_SOURCES = ["OCPP", "PARTNER"];
export const evSessionSourceSchema = z.enum(EV_SESSION_SOURCES);
export const EV_IDENTIFICATIONS = ["APP", "RFID", "POS", "WEB", "FLEET_CARD", "PARTNER", "UNKNOWN"];
export const evIdentificationSchema = z.enum(EV_IDENTIFICATIONS);
export const EV_IDENTIFICATION_LABELS = {
    APP: "Müşteri uygulaması",
    RFID: "Kart / etiket",
    POS: "Kasadan başlatma",
    WEB: "Panelden başlatma",
    FLEET_CARD: "Filo kartı",
    PARTNER: "Şarj ağı",
    UNKNOWN: "Tanınmayan (kasada ödenir)",
};
export const EV_PAYMENT_STATUSES = ["UNPAID", "PAID", "COVERED", "BILLED", "FREE"];
export const evPaymentStatusSchema = z.enum(EV_PAYMENT_STATUSES);
export const EV_PAYMENT_STATUS_LABELS = {
    UNPAID: "Ödenmedi",
    PAID: "Ödendi",
    COVERED: "Abonelikle karşılandı",
    BILLED: "Faturalandı",
    FREE: "Ücretsiz",
};
export const EV_PAYMENT_METHODS = [
    "POS",
    "FLEET_INVOICE",
    "CUSTOMER_INVOICE",
    "SUBSCRIPTION",
    "PARTNER",
    "FREE",
];
export const evPaymentMethodSchema = z.enum(EV_PAYMENT_METHODS);
export const EV_PAYMENT_METHOD_LABELS = {
    POS: "Kasa",
    FLEET_INVOICE: "Filo carisi faturası",
    CUSTOMER_INVOICE: "Müşteri faturası",
    SUBSCRIPTION: "Abonelik",
    PARTNER: "Şarj ağı",
    FREE: "Ücretsiz",
};
export const EV_INVOICE_STATUSES = ["NONE", "PENDING", "ISSUED", "FAILED"];
export const evInvoiceStatusSchema = z.enum(EV_INVOICE_STATUSES);
export const EV_CHARGE_COMPONENTS = ["ENERGY", "TIME", "IDLE"];
export const evChargeComponentSchema = z.enum(EV_CHARGE_COMPONENTS);
export const EV_CHARGE_COMPONENT_LABELS = {
    ENERGY: "Enerji (kWh)",
    TIME: "Şarj süresi (dk)",
    IDLE: "Bekleme (dk)",
};
export const EV_TARIFF_SCOPES = ["COMPANY", "STATION", "POWER_CLASS", "CHARGER"];
export const evTariffScopeSchema = z.enum(EV_TARIFF_SCOPES);
export const EV_TARIFF_SCOPE_LABELS = {
    COMPANY: "Şirket varsayılanı",
    STATION: "İstasyon",
    POWER_CLASS: "Güç sınıfı (AC / DC, kW)",
    CHARGER: "Ünite",
};
export const EV_CURRENT_TYPES = ["AC", "DC"];
export const evCurrentTypeSchema = z.enum(EV_CURRENT_TYPES);
export const EV_COMMAND_TYPES = [
    "RemoteStartTransaction",
    "RemoteStopTransaction",
    "ChangeAvailability",
    "Reset",
    "UnlockConnector",
    "SetChargingProfile",
    "ClearChargingProfile",
    "GetConfiguration",
    "ChangeConfiguration",
    "UpdateFirmware",
    "GetDiagnostics",
];
export const evCommandTypeSchema = z.enum(EV_COMMAND_TYPES);
export const EV_COMMAND_TYPE_LABELS = {
    RemoteStartTransaction: "Uzaktan başlat",
    RemoteStopTransaction: "Uzaktan durdur",
    ChangeAvailability: "Erişilebilirlik",
    Reset: "Yeniden başlat",
    UnlockConnector: "Kilidi aç",
    SetChargingProfile: "Güç sınırı",
    ClearChargingProfile: "Güç sınırını kaldır",
    GetConfiguration: "Yapılandırmayı oku",
    ChangeConfiguration: "Yapılandırmayı değiştir",
    UpdateFirmware: "Yazılım güncelle",
    GetDiagnostics: "Tanılama dosyası",
};
export const EV_COMMAND_STATUSES = [
    "PENDING",
    "SENT",
    "ACCEPTED",
    "REJECTED",
    "FAILED",
    "TIMEOUT",
    "EXPIRED",
];
export const evCommandStatusSchema = z.enum(EV_COMMAND_STATUSES);
export const EV_COMMAND_STATUS_LABELS = {
    PENDING: "Sırada",
    SENT: "Gönderildi",
    ACCEPTED: "Kabul edildi",
    REJECTED: "Reddedildi",
    FAILED: "Hata",
    TIMEOUT: "Yanıt yok",
    EXPIRED: "Süresi doldu (ünite bağlı değil)",
};
export const EV_COMMAND_SOURCES = ["WEB", "APP", "POS", "LOAD_MANAGER", "SYSTEM"];
export const evCommandSourceSchema = z.enum(EV_COMMAND_SOURCES);
/** Komut türüne göre kuyruk ömrü (sn) — `docs/domain/ocpp.md` §4. */
export const EV_COMMAND_TTL_SECONDS = {
    RemoteStartTransaction: 60,
    RemoteStopTransaction: 60,
    ChangeAvailability: 300,
    Reset: 300,
    UnlockConnector: 60,
    SetChargingProfile: 60,
    ClearChargingProfile: 60,
    GetConfiguration: 60,
    ChangeConfiguration: 60,
    UpdateFirmware: 3600,
    GetDiagnostics: 3600,
};
export const EV_ID_TOKEN_PURPOSES = ["APP", "POS", "WEB"];
export const evIdTokenPurposeSchema = z.enum(EV_ID_TOKEN_PURPOSES);
export const EV_LIMIT_REASONS = [
    "SESSION_STARTED",
    "SESSION_FINISHED",
    "PERIODIC",
    "SETTINGS_CHANGED",
    "CONNECTOR_CHANGED",
];
export const evLimitReasonSchema = z.enum(EV_LIMIT_REASONS);
export const EV_CONNECTION_CLOSE_REASONS = [
    "CLOSED",
    "REPLACED",
    "PING_TIMEOUT",
    "SERVER_SHUTDOWN",
    "STALE_INSTANCE",
    "ERROR",
];
export const evConnectionCloseReasonSchema = z.enum(EV_CONNECTION_CLOSE_REASONS);
/** Düzenleyici dışa aktarımda seçilebilecek alanlar (KAPALI liste, #74). Kişisel veri alanı YOKTUR. */
export const EV_EXPORT_FIELD_KEYS = [
    "sessionId",
    "stationCode",
    "stationName",
    "chargerName",
    "ocppIdentity",
    "connectorNo",
    "connectorType",
    "powerKw",
    "currentType",
    "startedAt",
    "chargingEndedAt",
    "completedAt",
    "energyKwh",
    "chargingMinutes",
    "idleMinutes",
    "energyAmount",
    "timeAmount",
    "idleAmount",
    "totalAmount",
    "paymentStatus",
    "paymentMethod",
    "identification",
    "source",
];
export const evExportFieldKeySchema = z.enum(EV_EXPORT_FIELD_KEYS);
/**
 * Çalışma zamanının `ev_sessions.warnings`'e yazdığı oturum / bağlantı uyarı kodları (ödeme bağının kodları
 * `EV_PAYMENT_WARNINGS`'te). Panel ve raporlar Türkçe etiketi buradan alır.
 */
export const EV_SESSION_WARNINGS = {
    /** Bilinmeyen `transactionId` ile gelen MeterValues / StopTransaction için sunucunun açtığı oturum. */
    RECOVERED_SESSION: "RECOVERED_SESSION",
    /** Mesaj zamanı sunucu saatinden 5 dk'dan fazla ileride → sunucu saatine çekildi. */
    FUTURE_TIMESTAMP_CLAMPED: "FUTURE_TIMESTAMP_CLAMPED",
    /** Aynı konnektörde yeni oturum başladı; eski canlı oturum kapatıldı (StopTransaction gelmedi). */
    SUPERSEDED_BY_NEW_TRANSACTION: "SUPERSEDED_BY_NEW_TRANSACTION",
    /** idTag başlangıçta kabul edilmedi (ünite oturumu durdurmalı). */
    ID_TAG_REJECTED: "ID_TAG_REJECTED",
    /** Konnektör tanımlı değil (ev_connectors'ta yok). */
    UNKNOWN_CONNECTOR: "UNKNOWN_CONNECTOR",
    /** Oturum başladığında yürürlükte tarife yok → tutar hesaplanamadı. */
    NO_TARIFF: "NO_TARIFF",
    /** Sayaç geri gitti / bitiş başlangıçtan küçük → enerji 0. */
    METER_DECREASED: "METER_DECREASED",
    /** Kurtarılan oturumda başlangıç sayacı bilinmiyor (ilk enerji örneği / bitiş sayacı kullanıldı). */
    METER_START_UNKNOWN: "METER_START_UNKNOWN",
    /** StopTransaction'da konnektör bilinmiyordu (ünitenin tek / canlı konnektörü varsayıldı). */
    CONNECTOR_ASSUMED: "CONNECTOR_ASSUMED",
    /** Abonelik hakkı kullanılamadı (dönem bitti / hak tükendi / kapsam dışı). */
    SUBSCRIPTION_NOT_APPLIED: "SUBSCRIPTION_NOT_APPLIED",
    /** Oturum yönetici eylemiyle kapatıldı (takılı oturum). */
    CLOSED_BY_OPERATOR: "CLOSED_BY_OPERATOR",
    /** Tamamlanmış oturuma geç gelen StopTransaction (sayaç / neden yazılamadı). */
    LATE_STOP_TRANSACTION: "LATE_STOP_TRANSACTION",
};
export const EV_SESSION_WARNING_LABELS = {
    RECOVERED_SESSION: "Kurtarılan oturum (başlangıç mesajı alınmadı)",
    FUTURE_TIMESTAMP_CLAMPED: "Ünite saati ileride; zaman sunucu saatine çekildi",
    SUPERSEDED_BY_NEW_TRANSACTION: "Aynı konnektörde yeni oturum başladı; bu oturum kapatıldı",
    ID_TAG_REJECTED: "Tanımlama başlangıçta reddedildi",
    UNKNOWN_CONNECTOR: "Konnektör tanımlı değil",
    NO_TARIFF: "Yürürlükte tarife yok; tutar hesaplanamadı",
    METER_DECREASED: "Sayaç geri gitti; enerji 0 sayıldı",
    METER_START_UNKNOWN: "Başlangıç sayacı bilinmiyor",
    CONNECTOR_ASSUMED: "Konnektör varsayıldı",
    SUBSCRIPTION_NOT_APPLIED: "Abonelik hakkı uygulanamadı",
    CLOSED_BY_OPERATOR: "Yönetici tarafından kapatıldı",
    LATE_STOP_TRANSACTION: "Tamamlanmış oturuma geç durdurma mesajı",
};
//# sourceMappingURL=enums.js.map